import React, { useEffect, useRef, useMemo } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

import Lozenge from '@atlaskit/lozenge';

import { fg } from '@confluence/feature-gating';
import {
	checkShouldShowLozenge,
	iterateLozengeShownTracker,
} from '@confluence/live-pages-utils/entry-points/liveDocsLozengeUtils.ts';

const i18n = defineMessages({
	new: {
		id: 'live-pages-features.new.lozenge',
		defaultMessage: 'New',
		description: 'Text for the new lozenge. Informs users that the associated feature is new.',
	},
});

type LivePagesBetaLozengeProps = {
	bold?: boolean;
};

export const LivePagesBetaLozenge = ({ bold = false }: LivePagesBetaLozengeProps) => {
	// shouldShowLozenge should be stabilized so it is not checked each re-render
	// we also do not want the lozenge to suddenly disappear if it's already shown
	const shouldShowLozenge = useMemo(() => checkShouldShowLozenge(), []);
	const hasIteratedShownTracker = useRef<boolean>(false);

	useEffect(() => {
		if (shouldShowLozenge && hasIteratedShownTracker.current === false) {
			iterateLozengeShownTracker();
			hasIteratedShownTracker.current = true;
		}
	}, [shouldShowLozenge]);

	// Lozenge is always removed only on Hello.
	if (fg('confluence_remove_live_page_lozenge_hello') || !shouldShowLozenge) {
		return null;
	}

	return (
		<Lozenge appearance="new" isBold={bold}>
			<FormattedMessage {...i18n.new} />
		</Lozenge>
	);
};
